<div id="notification-modal-container-container">

  <app-notification-modal
    (storesChange)="onSelectedStoresChange($event)"
    [filterChips]="(filterChips$ | ngrxPush)"
    [isUserScrollLoading]="(isUserScrollLoading$ | ngrxPush)"
    [lastDocumentId]="(lastDocumentId$ | ngrxPush)"
    [notificationsPerStore]="(notifications$ | ngrxPush)"
    [stores]="(userStores$ | ngrxPush)"
    [triggerMarkAllAsRead]="markAllAsReadTrigger"
    [userSelectedNotification]="(userSelectedNotification$ | ngrxPush)"
    [user]="(user$ | ngrxPush)">
  </app-notification-modal>

  <footer class="notification-footer">
    <app-shared-button
      (click)="onMarkAllAsRead()"
      [disabled]="getIsMarkAllAsReadDisabled"
      [fill]="true"
      [ngClass]="getIsMarkAllAsReadDisabled ? 'disabled' : ''">
      <app-display-icon
        [colour]="iconColourEnum.black"
        [icon]="icons.checkAll"
        [tooltip]="'Mark All as Read'">
      </app-display-icon>
      Mark all as read
    </app-shared-button>
  </footer>

</div>
